import { useSnapshot } from 'valtio'
import React, { type ReactElement, useEffect } from 'react'
import { ErrorDisplay } from '../../../../../shared/components/ui/forms/ErrorDisplay'
import Success from '../../../../../shared/components/ui/Success'
import { proxyChangePassword, resetProxyChangePassword } from '../../../../../shared/proxies/changePasswordProxy'
import { UserInfo } from '../UserInfo'
import { SubmitButton } from '../../../../../shared/components/ui/buttons/SubmitButton'
import { StandardInput } from '../../../../../shared/components/ui/forms/StandardInput'
import { InputFieldType } from '../../../../../shared/types/InputFieldType'
import { handleBlur, handleChange, handleFormSubmit } from './utils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export function ChangePasswordForm (): ReactElement {
  const { allowSubmit, apiCall: { error, loading }, completed, formValues, showPasswordError, showPasswordConfirmationError, formErrors } = useSnapshot(proxyChangePassword)

  useEffect(() => () => { resetProxyChangePassword() }, [])

  return (
    <>
      <div className="flex  flex-col justify-center sm:px-6 lg:px-8">
        <div className=" sm:mx-auto sm:w-full sm:max-w-md">

          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <UserInfo />
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <h2 className="mt-4 text-center text-xl font-bold tracking-tight text-gray-900">Update Your Password</h2>
              <hr className="mb-4 border-2" />
              {
                  error &&
                  (
                    <ErrorDisplay error={error} />
                  )
                }
              {
                  completed
                    ? <Success />
                    : (
                      <>
                        <div className="flex space-x-4">
                          <div className="w-full md:w-1/2" />
                          <div className="w-full md:w-1/2" />
                        </div>
                        <div className="px-4 w-full" />
                      </>
                      )
                }
            </div>

            <form onSubmit={handleFormSubmit}>
              <div className="mb-4">
                <StandardInput
                  label="New Password"
                  inputType={InputFieldType.Password}
                  onChange={handleChange(FormFieldNamesEnum.Password)}
                  onBlur={handleBlur(FormFieldNamesEnum.Password)}
                  placeholder="Password"
                  errorMessage={formErrors[FormFieldNamesEnum.Password] ?? ''}
                  showError={showPasswordError}
                  value={formValues[FormFieldNamesEnum.Password] ?? ''}
                />
              </div>

              <div>
                <StandardInput
                  label="Confirm Password"
                  inputType={InputFieldType.Password}
                  onChange={handleChange(FormFieldNamesEnum.PasswordConfirmation)}
                  onBlur={handleBlur(FormFieldNamesEnum.PasswordConfirmation)}
                  placeholder="Confirm Password"
                  errorMessage={formErrors[FormFieldNamesEnum.PasswordConfirmation] ?? ''}
                  showError={showPasswordConfirmationError}
                  value={formValues[FormFieldNamesEnum.PasswordConfirmation] ?? ''}
                />
              </div>

              <div className="w-full mx-2">
                <SubmitButton widthFull text="Submit" disabled={!allowSubmit} anyLoading={loading} />
              </div>
            </form>
          </div>
        </div>
      </div>

    </>

  )
}
